import {
  ACQUISITION_PREFS,
  DESIGNER_ROLES,
} from "../../components/homeowner-preferences-quiz/constants";

export const HIRE_LIKELIHOOD_OPTIONS = [
  {
    value: "It's an absolute, just need to find the right designer.",
    tooltip: "High urgency. This homeowner is ready to move forward.",
  },
  {
    value: "Warm Opportunity: Highly likely, with the right match",
    tooltip: "Strong intent, but fit matters. Build trust and stand out.",
  },
  {
    value: "Not likely, just dreaming/researching options",
    tooltip: "Low urgency. Exploring options or planning ahead.",
  },
];

export const OTHER_REASON_FOR_HIRING = "Other";

const LEGACY_REASON_FOR_HIRING_MAP: Record<string, string> = {
  "Needs Full-Service Guidance": "The thought of doing is by myself is overwhelming",
  "Event-Driven Makeover": "Planning an upcoming event in our home",
  "Just Moved In": "Just moved in and want to personalize our space",
  "Ready for a Refresh": "Lived in the home for a while and it's time for an update",
};

export const normalizeReasonForHiring = (value?: string | null) => {
  if (!value) return "";
  const trimmed = value.trim();
  if (trimmed === OTHER_REASON_FOR_HIRING || trimmed === "Other: Write in") {
    return OTHER_REASON_FOR_HIRING;
  }
  return LEGACY_REASON_FOR_HIRING_MAP[trimmed] ?? trimmed;
};

export const REASON_FOR_HIRING_OPTIONS = [
  {
    value: "The thought of doing is by myself is overwhelming",
    tooltip: "The thought of doing is by myself is overwhelming",
  },
  {
    value: "Planning an upcoming event in our home",
    tooltip: "Planning an upcoming event in our home",
  },
  {
    value: "Just moved in and want to personalize our space",
    tooltip: "Just moved in and want to personalize our space",
  },
  {
    value: "Lived in the home for a while and it's time for an update",
    tooltip: "Lived in the home for a while and it's time for an update",
  },
  {
    value: OTHER_REASON_FOR_HIRING,
    tooltip: "",
  },
];

export const OWNERSHIP_DURATION_OPTIONS = [
  "Just Moved In!",
  "1-3 Months",
  "4-11 Months",
  "1 - 3 Years",
  "4 - 10 Years",
  "10+ Years",
];

export const PROPERTY_DETAILS_OPTIONS = [
  "Short Term",
  "Long Term",
  "Both",
];

export const RESIDENCE_TYPE_OPTIONS = [
  "Single Family Home",
  "Condo/Townhouse/Apartment",
  "Multi-Family Home",
];

export const PROPERTY_LOCATION_OPTIONS = ["Rural", "Suburban", "Urban"];

export const SQUARE_FOOTAGE_OPTIONS = [
  "1,000 - 3,000 Square Feet",
  "3,001 - 6,000 Square Feet",
  "6,001 - 10,001 Square Feet",
  "10,000 + Square Feet",
];

export const BEDROOM_OPTIONS = ["1", "2", "3", "4", "5", "6+"];

export const BATHROOM_OPTIONS = ["1", "2", "3", "4", "5", "6+"];

export const DECISION_MAKER_OPTIONS = [
  "Myself (client)",
  "My significant other/partner",
  "Combination of myself (client) & my significant other",
  "A third party",
];

export const HOBBY_OPTIONS = [
  "Gardening",
  "DIY/Home Improvement",
  "Interior Decorating",
  "Cooking/Baking",
  "Entertaining at Home",
  "Collecting (e.g. art, antiques)",
  "Organizing/Decluttering",
  "Sustainable Living",
  "Home Tech & Smart Devices",
  "Painting/Drawing",
  "Photography",
  "Writing/Blogging",
  "Pottery/Ceramics",
  "Knitting/Crocheting",
  "Crafting",
  "Floral Arranging",
  "Music (playing or listening)",
  "Yoga",
  "Meditation",
  "Journaling",
  "Spa & Self-Care",
  "Personal Development",
  "Wine Tasting",
  "Coffee Culture",
  "Cooking Classes",
  "Mixology/Cocktails",
  "Farmers Markets",
  "Traveling",
  "Architecture Tours",
  "Museum Visits",
  "Language Learning",
  "Cultural Festivals",
  "Hiking",
  "Biking",
  "Fitness/Gym",
  "Running",
  "Skiing/Snowboarding",
  "Water Sports",
  "Social Media",
  "Podcasts",
  "Reading/Book Clubs",
  "Volunteering",
  "Gaming",
];

export const PET_TYPE_OPTIONS = [
  "Dog",
  "Cat",
  "Fist/Aquarium",
  "Bird",
  "Rabbit",
  "Guinea pig",
  "Hamster / Gerbil",
  "Ferret",
  "Reptile",
  "Turtle / Tortoise",
  "Frog / Amphibian",
  "Chicken",
  "Other",
];

export const PROJECT_PROPERTY_TYPE_OPTIONS = [
  { value: "PrimaryResidence", label: "Primary Residence" },
  { value: "VacationHomeLakeHouse", label: "Vacation Home: Lake House Design" },
  { value: "VacationHomeBeachHouse", label: "Vacation Home: Coastal Living Design/Beach House" },
  { value: "VacationHomeLodge", label: "Vacation Home: Mountain/Lodge Design" },
  { value: "RentalProperty", label: "Rental Property/AirBnB Design" },
  { value: "SmallCommercial", label: "Small Commercial Projects" },
  { value: "Other", label: "Other" },
];

export const PROJECT_SCOPE_OPTIONS = [
  { value: "FULL_HOME", label: "Full Home Design" },
  { value: "LIVING_ROOM", label: "Living Room Design" },
  { value: "DINING_ROOM", label: "Dining Room Design" },
  { value: "KITCHEN", label: "Kitchen Design" },
  { value: "PRIMARY_BATHROOM", label: "Primary Bathroom Design" },
  { value: "OTHER_BATHROOM", label: "Other Bathroom Design" },
  { value: "PRIMARY_BEDROOM", label: "Primary Bedroom Design" },
  { value: "GUEST_BEDROOM", label: "Guest Bedroom Design" },
  { value: "KIDS_BEDROOM", label: "Kids Bedroom" },
  { value: "BASEMENT", label: "Basement Design" },
  { value: "MUDROOM", label: "Mudroom Design" },
  { value: "ENTRYDESIGN", label: "Entry Design" },
  { value: "OUTDOOR_SPACE", label: "Outdoor Space Design" },
  { value: "SPACE_PLANNING", label: "Space Planning" },
  { value: "COLOR_CONSULTING", label: "Color Consulting" },
  { value: "LIGHTING", label: "Lighting Design" },
  { value: "FURNITURE_SELECTION", label: "Furniture Selection" },
  { value: "FAMILY_ROOM", label: "Living Room Design" },
  { value: "EVENT_DECOR", label: "Event/Holiday Decor" },
  { value: "ART_SELECTION", label: "Art Selection" },
  { value: "ANTIQUE_SELECTION", label: "Antique Selection" },
  { value: "HOME_STAGING", label: "Home Staging" },
  { value: "HOME_OFFICE", label: "Home Office Design" },
  { value: "OTHER", label: "Other" },
];

export const PROJECT_SPECIAL_REQUIREMENT_OPTIONS = [
  {
    value: "ACCESSIBILITY_FEATURES_FOR_DISABILITIES",
    label: "Accessibility Features For Disabilities",
  },
  { value: "PET_FRIENDLY_ELEMENTS", label: "Pet-Friendly Design Elements" },
  { value: "SMART_HOME_INTEGRATION", label: "Smart Home Integration" },
  { value: "CUSTOM_STORAGE_SOLUTIONS", label: "Custom Storage Solutions" },
  { value: "SPECIFIC_ACOUSTIC_TREATMENTS", label: "Specific Acoustic Treatments" },
  {
    value: "ENVIRONMENTALLY_SUSTAINABLE_MATERIALS",
    label: "Environmentally Sustainable Materials",
  },
  { value: "UNIQUE_LIGHTING_EFFECTS", label: "Unique Lighting Effects" },
  {
    value: "HISTORICAL_PRESERCATION_CONSIDERATION",
    label: "Historical Preservation Consideration",
  },
  { value: "OUTDOOR_LIVING_CONNECTIONS", label: "Outdoor Living Connections" },
  { value: "SPECIALIZED_VENTILATION_SYSTEMS", label: "Specialized Ventilation Systems" },
  { value: "FENG_SHUI", label: "Feng Shui" },
  { value: "ART_INTEGRATION", label: "Art Integration" },
  { value: "WINE_CELLAR", label: "Wine Cellar" },
  { value: "HOME_GYM", label: "Home Gym" },
  { value: "OTHER", label: "Other" },
];

export const FURNITURE_PREFERENCE_OPTIONS = [
  ...DESIGNER_ROLES.map((option) => ({ value: option.value, label: option.label })),
  ...ACQUISITION_PREFS.map((option) => ({ value: option.value, label: option.label })),
];

export const PRIORITY_LABELS: Record<string, string> = {
  COMPATIBLE_PERSONALITIES: "Compatible Personalities",
  BUDGET: "Budget",
  TIMELINE: "Timeline",
  HOW_DESIGNER_BILLS: "How the Designer Bills",
  STYLE: "Style",
  PROJECT_FINANCING: "Project Financing is Offered",
  DESIGNER_YEARS_EXPERIENCE: "Designer Years of Experience",
  COMPATIBLE_PERSONAL_PREFERENCES: "Compatible Personal Preferences",
  IDEAL_DESIGNER_TRAITS: "Ideal Designer Traits",
  PROJECT_SPECIAL_NEEDS: "Project Special Needs",
};
